<template>
  <section class="sectionBox">
    <!-- 左侧导航栏 -->
    <div class="left_box">
      <el-menu :router="true" class="el-menu-vertical-demo" background-color="#014f86"
        text-color="#fff" unique-opened active-text-color="#0074ff" >
        <!-- 1 -->
        <template v-for="i in menu">
          <el-submenu v-if="i.children && i.children.length>0" :index="''+(i.path!=''&&i.path!=null?i.path:i.id)" :key="i.id" >
            <template slot="title">
              <span style="color:#fff">{{i.title}}</span>
            </template>
            <!-- 子选项 -->
            <template v-for="j in i.children">
              <el-submenu :index="''+(j.path!=''&&j.path!=null?j.path:j.id)" v-if="j.children && j.children.length>0" :key="j.id" >
                <template slot="title">{{j.title}}</template>
                <el-menu-item v-for="k in j.children" :key="k.id" :index="k.path">
                  {{k.title}}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :key="j.id" :index="j.path">{{j.title}}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :key="i.id" :index="i.path">{{i.title}}</el-menu-item>
        </template>
      </el-menu>
    </div>
    <!-- 右侧内容区域 -->
    <div class="right_box">
      <!-- 面包屑导航 -->
      <div v-show="pageName!=''" class="mianbao">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/communityServices' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/businessGuideIndex' }">办事指南</el-breadcrumb-item>
            <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <transition name="mains" enter-active-class="animated bounce">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {
        menu() {
            let arr = [];
            // let menu = this.$store.state.menu;
            // for (let item in menu) {
            //     if (
            //         menu[item].menuType == "1" &&
            //         menu[item].path == "communityIssue"
            //     ) {
            //         arr = menu[item].children;
            //     }
            // }
            arr = [
              {
                id:500,
                path: 'businessGuideIndex',
                menuType: '3',
                title: '办事指南',
              },{
                id:501,
                path: 'businessGuideList',
                menuType: '3',
                title: '指南列表管理',
              },{
                id:502,
                path: 'businessGuideType',
                menuType: '3',
                title: '分类管理',
              },{
                id:503,
                path: 'oneStopProcessing',
                menuType: '2',
                title: '一站式办理',
                children: [
                  {
                    id:504,
                    path: 'oneStopProcessing',
                    menuType: '3',
                    title: '证件办理',
                  },{
                    id:505,
                    path: 'oneStopProcessingTemplate',
                    menuType: '3',
                    title: '证件办理模板',
                  },{
                    id:506,
                    path: 'oneStopProcessingProve',
                    menuType: '3',
                    title: '证明开具',
                  },{
                    id:507,
                    path: 'oneStopProcessingConsult',
                    menuType: '3',
                    title: '政策咨询',
                  }
                ]
              }
            ]
            return arr;
        },
        pageName() {
            let name = ''
            let menu = this.menu;
            // console.log(menu)
            for (let item in menu) {
                if ( menu[item].path == this.$route.name ) {
                    name = menu[item].title;
                    break
                }else if(menu[item].children && menu[item].children.length > 0){
                    for (let item1 in menu[item].children) {
                        if ( menu[item].children[item1].path == this.$route.name ) {
                            name = menu[item].children[item1].title;
                            break
                        }
                    }
                }
            }
            // console.log('title-'+name)
            return name
        }
    },
    mounted() {}
};
</script>
